import { getRequest } from "api/commonActions/get";
import { AxiosResponse } from "axios";
import { Requests } from "config/api";
import {
  GetTodayStatProps,
  GetTodayStatReturnType,
  GetTotalStatProps,
  GetTotalStatReturnType,
} from "declarations/statServices";

export const GetTotalStat = async ({
  setLoading,
}: GetTotalStatProps): Promise<GetTotalStatReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getTotalStat,
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const stat = response.data?.stat;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      stat,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};

export const GetTodayStat = async ({
  setLoading,
}: GetTodayStatProps): Promise<GetTodayStatReturnType> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getTodayStat,
    });
    setLoading && setLoading(false);

    const status = response?.status;
    const stat = response.data?.stat;
    const message = response?.data?.msg;

    return {
      status: status,
      message: message,
      stat,
    };
  } catch (error) {
    setLoading && setLoading(false);
    throw error;
  }
};
